// Shared BIR branch-code formatting (docs/WHT_IMPLEMENTATION.md D4).
//
// AccountingClient.branchCode is stored as entered: 4 or 5 digits.
// - Forms (2307, 0619-E, 1601-EQ, …) display 5 digits, left-padded.
// - DAT exports (SAWT, QAP) emit 4 digits, as in the BIR-accepted samples.
//   A 5-digit code can only drop its leading digit when that digit is 0;
//   anything else would name a different branch, so the export must block.
//
// A missing code is the head office, '0000' — the model's default.

export const FORM_BRANCH_WIDTH = 5;
export const DAT_BRANCH_WIDTH = 4;

const DEFAULT_BRANCH = '0000';

/**
 * Format a stored branch code for a form (width 5) or a DAT file (width 4).
 * Returns null when the code is not 4–5 digits, or when width is 4 and a
 * 5-digit code does not start with 0 — callers must treat null as blocking.
 */
export function formatBranch(code, width = FORM_BRANCH_WIDTH) {
  const raw = code == null || String(code).trim() === '' ? DEFAULT_BRANCH : String(code).trim();
  if (!/^\d{4,5}$/.test(raw)) return null;

  const padded = raw.padStart(FORM_BRANCH_WIDTH, '0');
  if (width === FORM_BRANCH_WIDTH) return padded;
  if (width === DAT_BRANCH_WIDTH) return padded[0] === '0' ? padded.slice(1) : null;
  return null;
}

/**
 * Filer branch for buildSawtDat: the 4-digit DAT form when there is one,
 * otherwise the stored code unchanged so the exporter's 4-digit check rejects
 * it and names the offending value in its error.
 */
export function datFilerBranch(code) {
  return formatBranch(code, DAT_BRANCH_WIDTH) ?? String(code ?? '');
}
